export default __webpack_public_path__ + "static/media/logo-light.9652bc5b.svg";